var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOmniflix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75px",
    height: "75px",
    viewBox: "0 0 75 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Logo/onmiflix") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Logo/onmiflix",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4512809,40.3042016 C62.1969351,44.1602326 61.4439786,52.5821679 61.4439786,52.5821679 C45.9751696,74.3928789 21.7854894,61.3840499 20.6222598,58.7586323 C20.6222598,58.7586323 29.5544322,52.9638513 39.4959104,47.7119503 L40.445516,47.2136134 L40.445516,47.2136134 L41.3997037,46.7197758 C46.6575492,44.0182726 52.0543024,41.5761296 56.4512809,40.3042016 Z M35.5705272,10 C27.4489522,12.4465069 24.9775519,26.4823084 28.1563261,52.1074047 C25.6018267,53.6392163 22.6245161,55.3184923 19.2243945,57.1452326 C11.0656782,47.1964075 8.97713384,37.154447 12.9587615,27.0193512 C16.9403891,16.8842553 24.4776443,11.2111383 35.5705272,10 Z M37.3611904,10 C45.000303,10 51.3636665,12.2502033 56.4512809,16.7506099 C70.1902035,27.9279888 63.2442085,49.5058615 63.2442085,49.5058615 C63.8182112,40.9801901 52.6720549,32.4446752 29.8057396,23.8993166 L29.8057396,23.8993166 L29.8104618,23.5421301 C29.9332379,18.9019398 32.4501474,14.3878964 37.3611904,10 Z",
    id: "Path-12",
    fill: "#C1C1D3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmniflix);
export default __webpack_public_path__ + "static/media/omniflix.21bbb0c91fd30583e4f8c7e23e508439.svg";
export { ForwardRef as ReactComponent };